import api from "../api";
import ApiConstant from "../../constants/api.constants";
import Helpers from "../../utils/helpers";
import { get } from "http";
import { complaintmodel } from "../../models/complaints/complaint-model";

const saveComplaint = async (complaint: any) => {
  return await api
    .put(ApiConstant.saveComplaint, complaint, {
      headers: {
        "content-type": "application/json",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error;
    });
}

interface ComplaintFilterParams {
  userId?: number;
  startDate?: string;
  endDate?: string;
  userID?: number;
  complaintCategoryId?: number;
  complaintTypeId?: number;
  statusId?: number;
  pageNumber?: number;
  pageSize?: number;
}



// }
interface ComplaintResponse {
  complaints: complaintmodel[];  // Use proper type instead of 'any'
  totalRecords: number;
  pageNumber?: number;
  pageSize?: number;
  totalPages?: number;
}





const getfilteredComplaints = async (filter: ComplaintFilterParams): Promise<ComplaintResponse> => {
  try {


    // console.log("API Request Payload:", JSON.stringify(requestBody, null, 2));

    const response = await api.post(ApiConstant.getfilteredComplaints, filter)

    // Ensure the response structure matches what your component expects
    return {
      totalRecords: response.data?.totalRecords || 0,
      complaints: response.data?.data || response.data?.complaints || [],
      // Add pagination metadata if available
      pageNumber: response.data?.pageNumber,
      pageSize: response.data?.pageSize,
      totalPages: response.data?.totalPages
    };
  } catch (error) {
    console.error("Error in getfilteredComplaints:", error);
    throw error;
  }
};

const getAllComplaints = async (pageSize: number, pageNo: number) => {
  try {
    var filter = {
      pageNumber: pageNo,
      pageSize: pageSize
    }
    const response = await api.post(ApiConstant.viewAllComplaints, filter);
    return response.data;
  } catch (error) {
    console.error("Error fetching paginated complaints:", error);
    return { data: [], totalRecords: 0 };
  }
};

const saveNewComplaint = async (complaint: any) => {
  return await api
    .post(ApiConstant.saveComplaint, complaint, {
      headers: {
        "content-type": "application/json",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error;
    });
}

export const getUserInvoices = async (userId: number) => {
  try {
    const Invoice = await api.get(ApiConstant.getUserInvoices + userId)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get order invoice list data.', error);
      });
    const response = Invoice != null ? Invoice : null;
    return response;
  } catch (e) {
    console.log('error in Invoice Details');
    return [];
  }
};

export const getInvoicedproducts = async (invoiceNo: number) => {
  try {
    const Products = await api.get(ApiConstant.getInvoicedproducts + invoiceNo)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get invoice products list data.', error);
      });
    const response = Products != null ? Products : null;
    return response;
  } catch (e) {
    console.log('error in product Details');
    return [];
  }
};

export const getProductCategory = async (product: number) => {
  try {
    const Category = await api.get(ApiConstant.getProductCategory + product)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get product category data.', error);
      });
    const response = Category != null ? Category : null;
    return response;
  } catch (e) {
    console.log('error in product Details');
    return [];
  }
};

export const getComplaintCategory = async () => {
  try {
    const CompCategory = await api.get(ApiConstant.getComplaintCategory)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get complaint category list data.', error);
      });
    const response = CompCategory != null ? CompCategory : null;
    return response;
  } catch (e) {
    console.log('error in compalint category Details');
    return [];
  }
};

export const getComplaintType = async () => {
  try {
    const CompType = await api.get(ApiConstant.getComplaintType)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get complaint type list data.', error);
      });
    const response = CompType != null ? CompType : null;
    return response;
  } catch (e) {
    console.log('error in compalint type Details');
    return [];
  }
};

export const getComplaintStatus = async () => {
  try {
    const CompStatus = await api.get(ApiConstant.getComplaintStatus)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get complaint status list data.', error);
      });
    const response = CompStatus != null ? CompStatus : null;
    return response;
  } catch (e) {
    console.log('error in compalint status Details');
    return [];
  }
};

const getAdminUsers = async (filter: string) => {
  try {
    const Users: any = await api
      .get(ApiConstant.getAdminUserList + filter)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get admin user list data.', error);
      });
    const response = Users != null ? Users : null;
    return response;
  }
  catch (e) {
    console.log('error in getAdminMobileData');
    return [];
  }
}

const updateComplaint = async (complaint: any) => {
  return await api
    .put(ApiConstant.updateComplaint, complaint, {
      headers: {
        "content-type": "application/json",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error;
    });
}

const getAdminDetailComplaint = async () => {
  try {
    const Users: any = await api
      .get(ApiConstant.getAdminDetailsComplaint)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get order user list data.', error);
      });
    const response = Users != null ? Users : null;
    return response;
  }
  catch (e) {
    console.log('error in getUserMobileData');
    return [];
  }
}

export const getUserAllInvoices = async (userId: number) => {
  try {
    const Invoice = await api.get(ApiConstant.getUserAllInvoices + userId)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get order invoice list data.', error);
      });
    const response = Invoice != null ? Invoice : null;
    return response;
  } catch (e) {
    console.log('error in Invoice Details');
    return [];
  }
};


export const getUserAllInvoicesList = async (filter: any) => {
  try {
    const Invoice = await api.post(ApiConstant.getUserAllInvoicesList, filter)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get order invoice list data.', error);
      });
    const response = Invoice != null ? Invoice : null;
    return response;
  } catch (e) {
    console.log('error in Invoice Details');
    return [];
  }
};


export const getUserInvoicesAll = async (userId: number) => {
  try {
    const Invoice = await api.get(ApiConstant.getUserInvoicesAll + userId)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get all order invoice list data.', error);
      });
    const response = Invoice != null ? Invoice : null;
    return response;
  } catch (e) {
    console.log('error in all invoice details');
    return [];
  }
};

export const InvoiceNumber = async (invoiceNo: number) => {
  try {
    const InvoiceNo = await api.get(ApiConstant.InvoiceNumber + invoiceNo)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get order invoice number list data.', error);
      });
    const response = InvoiceNo != null ? InvoiceNo : null;
    return response;
  } catch (e) {
    console.log('error in Invoice Number Details');
    return [];
  }
};

export const OrderInvoiceId = async (orderInvoiceId: number) => {
  try {
    const orderInvoiceIdNumber = await api.get(ApiConstant.OrderInvoiceId + orderInvoiceId)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get order invoice number list data.', error);
      });
    const response = orderInvoiceIdNumber != null ? orderInvoiceIdNumber : null;
    return response;
  } catch (e) {
    console.log('error in Invoice Number Details');
    return [];
  }
};

const CreateProductComplaint = async (complaint: any) => {

  const formData = new FormData();
  formData.append("CustomerId", complaint.CustomerId);
  formData.append("InvoiceId", complaint.InvoiceId);
  formData.append("ProductId", complaint.ProductId);
  formData.append("CategoryId", complaint.CategoryId);
  formData.append("Description", complaint.Description);
  formData.append("Severity", complaint.Severity);
  formData.append("Remarks", complaint.Remarks);
  formData.append("ContainerType", complaint.ContainerType);

  // ✅ append files
  if (complaint.Image && complaint.Image.length > 0) {
    complaint.Image.forEach((file: File) => {
      formData.append("Image", file); // must match C# property name
    });
  }
  return await api
    .post(ApiConstant.CreateProductComplaint, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error;
    });
}

const CreateServiceComplaint = async (complaint: any) => {
  const formData = new FormData();
  formData.append("CustomerId", complaint.CustomerId);
  formData.append("Description", complaint.Description);
  formData.append("Severity", complaint.Severity);
  formData.append("Remarks", complaint.Remarks);
  formData.append("ContainerType", complaint.ContainerType);
  formData.append("CustomerSupportAction", complaint.CustomerSupportAction);

  // ✅ append files
  if (complaint.Image && complaint.Image.length > 0) {
    complaint.Image.forEach((file: File) => {
      formData.append("Image", file); // must match C# property name
    });
  }
  return await api
    .post(ApiConstant.CreateServiceComplaint, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error;
    });
}

const CreateComplaintAction = async (complaint: any) => {

  const formData = new FormData();
  const safeAppend = (key: string, value: any) => {
    if (value !== null && value !== undefined) {
      formData.append(key, String(value));
    }
  };

  safeAppend("id", complaint.id);
  safeAppend("productComplaintId", complaint.productComplaintId);
  safeAppend("serviceComplaintId", complaint.serviceComplaintId);
  safeAppend("actionBy", complaint.actionBy);
  safeAppend("actionDate", complaint.actionDate);
  safeAppend("description", complaint.description);
  safeAppend("severity", complaint.severity);
  safeAppend("remarks", complaint.remarks ?? "");
  safeAppend("containerType", complaint.containerType);
  safeAppend("statusId", complaint.statusId);
  safeAppend("copqInRs", complaint.copqInRs);
  safeAppend("correctiveAction", complaint.correctiveAction);
  safeAppend("customerSupportAction", complaint.customerSupportAction);
  safeAppend("preventiveAction", complaint.preventiveAction);

  if (complaint.image && Array.isArray(complaint.image)) {
    complaint.image.forEach((file: File) => {
      formData.append("Image", file);
    });
  }

  return await api
    .post(ApiConstant.CreateComplaintAction, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error;
    });
}

export const GetAllProductComplaints = async () => {
  try {
    const GetProdComp = await api.get(ApiConstant.GetAllProductComplaints)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get product complaint list data.', error);
      });
    const response = GetProdComp != null ? GetProdComp : null;
    return response;
  } catch (e) {
    console.log('error in product compalint Details');
    return [];
  }
};

export const GetAllServiceComplaints = async () => {
  try {
    const GetServComp = await api.get(ApiConstant.GetAllServiceComplaints)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get service complaint list data.', error);
      });
    const response = GetServComp != null ? GetServComp : null;
    return response;
  } catch (e) {
    console.log('error in service compalint details');
    return [];
  }
};

export const GetAllComplaintActions = async () => {
  try {
    const GetCompAct = await api.get(ApiConstant.GetAllComplaintActions)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get complaint action list data.', error);
      });
    const response = GetCompAct != null ? GetCompAct : null;
    return response;
  } catch (e) {
    console.log('error in compalint action details');
    return [];
  }
};

const UpdateProductComplaintInfo = async (complaint: any) => {

  const formData = new FormData();
  formData.append("customerId", complaint.customerId);
  formData.append("invoiceId", complaint.invoiceId);
  formData.append("productId", complaint.productId);
  formData.append("categoryId", complaint.categoryId);
  formData.append("description", complaint.description);
  formData.append("severity", complaint.severity);
  formData.append("remarks", complaint.remarks);
  formData.append("id", complaint.id);
  formData.append("customerSupportAction", complaint.customerSupportAction);
  formData.append("containerType", complaint.containerType);

  // ✅ append files
  if (complaint.image && complaint.image.length > 0) {
    complaint.image.forEach((file: File) => {
      formData.append("image", file); // must match C# property name
    });
  }
  return await api
    .put(ApiConstant.UpdateProductComplaintInfo, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error;
    });
}

const UpdateServiceComplaintInfo = async (complaint: any) => {

  const formData = new FormData();
  formData.append("id", complaint.id);
  formData.append("customerId", complaint.customerId);
  formData.append("customerSupportAction", complaint.customerSupportAction);
  formData.append("description", complaint.description);
  formData.append("remarks", complaint.remarks);
  formData.append("severity", complaint.severity);
  formData.append("containerType", complaint.containerType);
  // ✅ append files
  if (complaint.image && complaint.image.length > 0) {
    complaint.image.forEach((file: File) => {
      formData.append("image", file); // must match C# property name
    });
  }
  return await api
    .put(ApiConstant.UpdateServiceComplaintInfo, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error;
    });
}
const CreateCustomerServiceComplaint = async (complaint: any) => {

  const formData = new FormData();
  formData.append("Description", complaint.Description);
  formData.append("CustomerId", complaint.CustomerId);
  formData.append("ContainerType", complaint.ContainerType);
  // ✅ append files
  if (complaint.Image && complaint.Image.length > 0) {
    complaint.Image.forEach((file: File) => {
      formData.append("Image", file); // must match C# property name
    });
  }
  return await api
    .post(ApiConstant.CreateCustomerServiceComplaint, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error;
    });
};

export const GetAllCustServiceComplaints = async () => {
  try {
    const GetServComp = await api.get(ApiConstant.GetAllCustServiceComplaints)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get service complaint list data.', error);
      });
    const response = GetServComp != null ? GetServComp : null;
    return response;
  } catch (e) {
    console.log('error in service compalint details');
    return [];
  }
};

const UpdateCustServiceComplaintInfo = async (complaint: any) => {

  const formData = new FormData();
  formData.append("id", complaint.id);
  formData.append("customerId", complaint.customerId);
  formData.append("description", complaint.description);
  formData.append("severity", complaint.severity);
  formData.append("remarks", complaint.remarks);
  formData.append("customerSupportAction", complaint.customerSupportAction);
  formData.append("containerType", complaint.containerType);
  // ✅ append files
  if (complaint.image && complaint.image.length > 0) {
    complaint.image.forEach((file: File) => {
      formData.append("image", file); // must match C# property name
    });
  }
  return await api
    .put(ApiConstant.UpdateCustServiceComplaintInfo, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error;
    });
};

const CreateCustProductComplaint = async (complaint: any) => {
  const formData = new FormData();
  formData.append("customerId", complaint.customerId);
  formData.append("invoiceId", complaint.invoiceId);
  formData.append("productId", complaint.productId);
  formData.append("categoryId", complaint.categoryId);
  formData.append("description", complaint.description);
  formData.append("severity", complaint.severity);
  formData.append("remarks", complaint.remarks);
  formData.append("customerSupportAction", complaint.customerSupportAction);
  formData.append("containerType", complaint.containerType);


  // ✅ append files
  if (complaint.image && complaint.image.length > 0) {
    complaint.image.forEach((file: File) => {
      formData.append("image", file); // must match C# property name
    });
  }
  return await api
    .post(ApiConstant.CreateCustProductComplaint, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error;
    });
};

export const GetAllCustProductComplaints = async () => {
  try {
    const GetServComp = await api.get(ApiConstant.GetAllCustProductComplaints)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get service complaint list data.', error);
      });
    const response = GetServComp != null ? GetServComp : null;
    return response;
  } catch (e) {
    console.log('error in service compalint details');
    return [];
  }
};

const UpdateCustProductComplaintInfo = async (complaint: any) => {

  const formData = new FormData();
  formData.append("id", complaint.id);
  formData.append("customerId", complaint.customerId);

  // ✅ append files
  if (complaint.image && complaint.image.length > 0) {
    complaint.image.forEach((file: File) => {
      formData.append("image", file); // must match C# property name
    });
  }
  return await api
    .put(ApiConstant.UpdateCustProductComplaintInfo, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error;
    });
};

const CreateInternalComplaint = async (complaint: any) => {

  const formData = new FormData();
  formData.append("complaintDescription", complaint.complaintDescription);
  formData.append("severity", complaint.severity);
  formData.append("containerType", complaint.containerType);

  // ✅ append files
  if (complaint.image && complaint.image.length > 0) {
    complaint.image.forEach((file: File) => {
      formData.append("image", file); // must match C# property name
    });
  }

  return await api
    .post(ApiConstant.CreateInternalComplaint, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error;
    });
}

const CreateInternalComplaintAction = async (payload: any) => {
  const fd = new FormData();

  const add = (k: string, v: any) => {
    if (v === undefined || v === null) return;
    if (v instanceof Date) fd.append(k, v.toISOString());
    else fd.append(k, String(v));
  };

  add("InternalComplaintId", payload.internalComplaintId);
  add("ActionAttachmentId", payload.actionAttachmentId);
  add("ActionBy", payload.actionBy);
  add("ActionDate", payload.actionDate ? new Date(payload.actionDate) : null);
  add("ActionDescription", payload.actionDescription);
  add("CopqInRs", payload.copqInRs);
  add("ContainerType", payload.containerType);
  add("Remarks", payload.remarks);
  add("CorrectiveAction", payload.correctiveAction);
  add("PreventiveAction", payload.preventiveAction);
  add("StatusId", payload.statusId);
  add("Severity", payload.severity);
  add("CustomerName", payload.customerName);
  add("CreatedByName", payload.createdByName);
  add("UpdatedByName", payload.updatedByName);
  add("Mobile", payload.mobile);

  if (payload.image && payload.image.length > 0) {
    payload.image.forEach((f: File) => fd.append("Image", f, f.name));
  }
  return await api
    .post(ApiConstant.CreateInternalComplaintAction, fd, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error;
    });

}

export const GetAllInternalComplaints = async () => {
  try {
    const GetIntCmp = await api.get(ApiConstant.GetAllInternalComplaints)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get complaint action list data.', error);
      });
    const response = GetIntCmp != null ? GetIntCmp : null;
    return response;
  } catch (e) {
    console.log('error in compalint action details');
    return [];
  }
};

export const GetAllInternalComplaintAction = async () => {
  try {
    const GetIntCmpAct = await api.get(ApiConstant.GetAllInternalComplaintAction)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get complaint action list data.', error);
      });
    const response = GetIntCmpAct != null ? GetIntCmpAct : null;
    return response;
  } catch (e) {
    console.log('error in compalint action details');
    return [];
  }
};

const UpdateInternalComplaint = async (complaint: any) => {

  const formData = new FormData();

  formData.append("id", complaint.id);
  formData.append("complaintDescription", complaint.complaintDescription);
  formData.append("severity", complaint.severity);
  formData.append("containerType", complaint.containerType);
  formData.append("updatedBy", complaint.updatedBy);

  // ✅ append files
  if (complaint.image && complaint.image.length > 0) {
    complaint.image.forEach((file: File) => {
      formData.append("image", file); // must match C# property name
    });
  }
  return await api
    .put(ApiConstant.UpdateInternalComplaint, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error;
    });
};

const ComplaintService = {
  saveComplaint,
  saveNewComplaint,
  getUserInvoices,
  getInvoicedproducts,
  getProductCategory,
  getComplaintCategory,
  getComplaintType,
  getComplaintStatus,
  getAdminUsers,
  getAllComplaints,
  updateComplaint,
  getAdminDetailComplaint,
  getUserAllInvoices,
  getUserAllInvoicesList,
  getfilteredComplaints,
  InvoiceNumber,
  OrderInvoiceId,
  getUserInvoicesAll,
  CreateProductComplaint,
  CreateServiceComplaint,
  CreateComplaintAction,
  GetAllProductComplaints,
  GetAllServiceComplaints,
  GetAllComplaintActions,
  UpdateProductComplaintInfo,
  UpdateServiceComplaintInfo,
  CreateCustomerServiceComplaint,
  GetAllCustServiceComplaints,
  UpdateCustServiceComplaintInfo,
  CreateCustProductComplaint,
  GetAllCustProductComplaints,
  UpdateCustProductComplaintInfo,
  CreateInternalComplaint,
  CreateInternalComplaintAction,
  GetAllInternalComplaints,
  UpdateInternalComplaint,
  GetAllInternalComplaintAction,
}

export default ComplaintService;